import {EVirtualizedTableCellType} from "../../components/Table/VirtualizedTableEnums";

export enum EOBColumnKey {
    OptionCodeKey = "optionCode",
    ExportStatus = "exportStatus",
    Sequence = "intSequence",
    ShorttextKey = "shorttext",
}

export class BaseOptionsTableUtils {
    /**
     * Returns the RowType using the key for base options
     * @param key
     */
    getRowTypeforBaseOption(key: string): EVirtualizedTableCellType {
        let returnValue: EVirtualizedTableCellType;
        switch (key) {
            case "optionCode":
                returnValue = EVirtualizedTableCellType.TEXTINPUT;
                break;
            case "statusView":
                returnValue = EVirtualizedTableCellType.WORKFLOWSTATE;
                break;
            case "categoryText":
                returnValue = EVirtualizedTableCellType.DROPDOWN;
                break;
            case "optionType":
                returnValue = EVirtualizedTableCellType.DROPDOWN;
                break;
            case "references":
                returnValue = EVirtualizedTableCellType.REFERENCE;
                break;
            case "partNumber":
                returnValue = EVirtualizedTableCellType.TEXTINPUT;
                break;
            case "comment":
                returnValue = EVirtualizedTableCellType.TEXTAREA;
                break;
            case "shorttext":
                returnValue = EVirtualizedTableCellType.TWOLANGUAGEINPUT;
                break;
            case "longtext":
                returnValue = EVirtualizedTableCellType.TWOLANGUAGETEXTAREA;
                break;
            case "intSequence":
                returnValue = EVirtualizedTableCellType.NUMBERINPUT;
                break;
            case "pdipMFamilie":
                returnValue = EVirtualizedTableCellType.TEXTINPUT;
                break;
            case "pdipMFamilieBez":
                returnValue = EVirtualizedTableCellType.TEXTINPUT;
                break;
            case "changedBy":
                returnValue = EVirtualizedTableCellType.TEXTINPUT;
                break;
            case "changedTimestamp":
                returnValue = EVirtualizedTableCellType.TEXTINPUT;
                break;
            default:
                returnValue = EVirtualizedTableCellType.DEFAULTINPUT;
                break;
        }
        return returnValue;
    }

    /**
     * Decides on the basis of the key
     * the default column width
     * @param key
     */
    getColumnDefaultWidth(key: string): number {
        let returnValue: number;
        switch (key) {
            case "optionCode":
                returnValue = 125;
                break;
            case "statusView":
                returnValue = 125;
                break;
            case "categoryText":
                returnValue = 140;
                break;
            case "optionType":
                returnValue = 180;
                break;
            case "references":
                returnValue = 90;
                break;
            case "partNumber":
                returnValue = 130;
                break;
            case "comment":
                returnValue = 150;
                break;
            case "shorttext":
                returnValue = 275;
                break;
            case "longtext":
                returnValue = 400;
                break;
            case "intSequence":
                returnValue = 100;
                break;
            case "pdipMFamilie":
                returnValue = 150;
                break;
            case "pdipMFamilieBez":
                returnValue = 250;
                break;
            case "changedBy":
                returnValue = 200;
                break;
            case "changedTimestamp":
                returnValue = 200;
                break;
            default:
                returnValue = 100;
                break;
        }
        return returnValue;
    }

    isRowReadOnlyBasicOptions(key: string, propReadOnly: boolean): boolean {
        let isReadOnly: boolean;
        switch (key) {
            case "references":
                isReadOnly = true;
                break;
            case "pdipMFamilie":
                isReadOnly = true;
                break;
            case "pdipMFamilieBez":
                isReadOnly = true;
                break;
            case "changedBy":
                isReadOnly = true;
                break;
            case "changedTimestamp":
                isReadOnly = true;
                break;
            default:
                isReadOnly = propReadOnly;
                break;
        }
        return isReadOnly;
    }

    isRowSortable(key: string): boolean {
        let sortable: boolean;
        switch (key) {
            case "references":
                sortable = false;
                break;
            case "shorttext":
                sortable = false;
                break;
            case "longtext":
                sortable = false;
                break;
            case "changedBy":
                sortable = false;
                break;
            default:
                sortable = true;
                break;
        }
        return sortable;
    }
}



// WEBPACK FOOTER //
// ./src/views/BaseOptionsView/BaseOptionsTableUtils.ts